/**
 * Returns the text of the link or the title/alt of the image in the link.
 */

export default ({ target, link }) => {
  const ariaLabel = target.ariaLabel;
  if (ariaLabel) {
    return ariaLabel;
  }

  let linkText = target.innerText;
  const image = target.querySelector("img");
  if (image && linkText === "") {
    const imageAlt = image.getAttribute("alt");
    if (imageAlt && imageAlt !== "") {
      linkText = imageAlt;
    } else {
      const imageTitle = image.getAttribute("title");
      if (imageTitle && imageTitle !== "") {
        linkText = imageTitle;
      }
    }
  }

  return linkText ? linkText : link;
};